module.exports = __webpack_public_path__ + "media/newstyle/images/esboco-691754612f7705c2b1dc155b8b0aedd2.svg";